import { currencyQuery } from './useCurrencies';

export const useCurrenciesMock = {
  request: {
    query: currencyQuery,
  },
  result: {
    data: {
      currencies: [
        {
          __typename: 'Currency',
          id: 'AUD',
          icon: 'Australia',
          name: 'AUD',
          symbol: '$',
          multiplier: 1.6588321035,
        },
        {
          __typename: 'Currency',
          id: 'BRL',
          icon: 'Brazil',
          name: 'BRL',
          symbol: 'R$',
          multiplier: 5.0929215633,
        },
        {
          __typename: 'Currency',
          id: 'CAD',
          icon: 'Canada',
          name: 'CAD',
          symbol: '$',
          multiplier: 1.4139564544,
        },
        {
          __typename: 'Currency',
          id: 'EUR',
          icon: 'EuropeanUnion',
          name: 'EUR',
          symbol: '€',
          multiplier: 0.9109957183,
        },
        {
          __typename: 'Currency',
          id: 'GBP',
          icon: 'GreatBritain',
          name: 'GBP',
          symbol: '£',
          multiplier: 0.8175548875,
        },
        {
          __typename: 'Currency',
          id: 'INR',
          icon: 'India',
          name: 'INR',
          symbol: '₹',
          multiplier: 75.4937596793,
        },
        {
          __typename: 'Currency',
          id: 'JPY',
          icon: 'Japan',
          name: 'JPY',
          symbol: '¥',
          multiplier: 108.7364489387,
        },
        {
          __typename: 'Currency',
          id: 'NZD',
          icon: 'NewZealand',
          name: 'NZD',
          symbol: '$',
          multiplier: 1.6897148583,
        },
        {
          __typename: 'Currency',
          id: 'USD',
          icon: 'UnitedStates',
          name: 'USD',
          symbol: '$',
          multiplier: 1,
        },
      ],
      selectedCurrency: {
        __typename: 'Currency',
        id: 'USD',
        icon: 'UnitedStates',
        name: 'USD',
        symbol: '$',
        multiplier: 1,
      },
    },
  },
};
